export default "/_next/static/images/5552663380324333b2b6f15294776da1.jpg";